import { ApiFragment } from '@stylehaven/components';

export interface SelectParentDialogOutputCancel {
    type: 'cancel';
}

export interface SelectParentDialogOutputSuccess {
    type: 'success';
    parentRecord: ApiFragment;
}

export type SelectParentDialogOutput = SelectParentDialogOutputCancel | SelectParentDialogOutputSuccess;

export enum SelectParentDialogType {
    UPLOAD,
    ADD
}
